import { Positioning, SIDEBAR_WIDTH } from "@bonusx-global/bx-design-system";
import { type IWithIsMobile } from "@bonusx-global/bx-design-system/dist/types/interfaces";
import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import { type PropsWithChildren } from "react";
import useIsMobile from "../../../hooks/device/useIsMobile";

function shouldForwardProp(prop: string) {
  return prop !== "isMobile";
}

const SidebarWrapper = styled(Box, { shouldForwardProp })<IWithIsMobile>(({ isMobile }) => ({
  position: Positioning.relative,
  width: isMobile ? 0 : SIDEBAR_WIDTH,
  minWidth: isMobile ? 0 : SIDEBAR_WIDTH,
  zIndex: 10,
  "& > .MuiBox-root:first-of-type": {
    position: "fixed",
    height: "100%",
  },
}));

export const sidebarLayoutWrapperId = "sidebar-layout-wrapper-id";

export function SidebarLayoutWrapper({ children }: Readonly<PropsWithChildren<{}>>) {
  const isMobile = useIsMobile();

  return (
    <SidebarWrapper id={sidebarLayoutWrapperId} data-testid={sidebarLayoutWrapperId} isMobile={isMobile}>
      <Box>{children}</Box>
    </SidebarWrapper>
  );
}
